/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AbilityContext } from '../../utilities/Can';
import defineAbilities from '../../utilities/defineAbilities';

function TodayLayout({ children, user }) {
  const ability = defineAbilities(user || { roles: ['guest'] });

  return (
    <AbilityContext.Provider value={ability}>
      <div className="today-display-layout">
        {children}
      </div>
    </AbilityContext.Provider>
  );
}

TodayLayout.propTypes = {
  children: PropTypes.any,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.Login.user,
});

export default connect(mapStateToProps)(TodayLayout);
